import React from 'react';
import { Columns } from '@components/Columns';
import {
  StyledSection,
  JoyButtonTextPairing,
  BrowserButtonShapeImage,
  StyledBrowserImage,
  StyledLeftImageWrapper,
  StyledButtonImage,
  Lottie,
  AppTopWave,
} from './RegistryJoyButtonSection.styles';
import { registryPageData } from '@data-ts/pages/registry';
// import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
// import { useHomeAnnouncementController } from './RegistryJoyButton.controller';
import { Box } from '@components/Box';

const registryJoyButtonSectionData = registryPageData.registryJoyButtonSection;

interface RegistryJoyButtonSectionProps {}

export const RegistryJoyButtonSection: React.FC<RegistryJoyButtonSectionProps> = () => {
  // const { lottieRef, initBodyMovinAnimation } = useHomeAnnouncementController();
  return (
    <StyledSection as="section" id="Joy_Button" paddingTop={[10, 14]} paddingBottom={[8, 10]}>
      <AppTopWave width={'100%'} height={74} src="registry-v2/registry-app/registry-app-top-wave.svg" />
      <Box paddingTop={[10]} paddingBottom={[10, 10, 0]} backgroundColor="humana1Light">
        <Columns centered>
          <Columns.Column width={6}>
            <StyledLeftImageWrapper id="new-lottie-container">
              <BrowserButtonShapeImage src="registry-v2/joy-button/joy-browser-button-shape.svg" />
              <StyledBrowserImage src="registry-v2/joy-button/registry-browser.png" />
              <StyledButtonImage src="registry-v2/joy-button/joy-browser-button.svg" />
              {/* <div>
              <LazyLoadWrapper beforeLoad={initBodyMovinAnimation}>
                <div />
              </LazyLoadWrapper>
              <Lottie ref={lottieRef}></Lottie>
            </div> */}
            </StyledLeftImageWrapper>
          </Columns.Column>
          <Columns.Column width={4}>
            <JoyButtonTextPairing
              eyebrow={registryJoyButtonSectionData.eyebrow}
              eyebrowColor="humana5"
              eyebrowVariant="sectionEyeBrow20"
              eyebrowTagName="h2"
              title={registryJoyButtonSectionData.title}
              titleVariant="hed40"
              titleColor="humana5"
              titleTagName="h2"
              body={registryJoyButtonSectionData.body}
              bodyVariant="dek20"
              bodyColor="neutra6"
              bodyTagName="p"
            />
          </Columns.Column>
        </Columns>
      </Box>
    </StyledSection>
  );
};
